module.exports = __webpack_public_path__ + "img/2.2860dfa2.png";